export type FileType = undefined | 'image' | 'video' | 'audio' | 'document' | 'pdf';

export const getFileTypeByName = (name: string): FileType => {
  const ext = name.split('.').pop()?.toLowerCase();

  if (!ext) {
    return undefined;
  }

  if (['webp', 'png', 'jpg', 'jpeg', 'svg', 'gif'].includes(ext)) {
    return 'image';
  }

  if (['mp4', 'avi', 'mkv', 'mov', 'wmv'].includes(ext)) {
    return 'video';
  }

  if (['mp3', 'wav', 'ogg', 'aac'].includes(ext)) {
    return 'audio';
  }

  if (['doc', 'docx', 'txt', 'rtf'].includes(ext)) {
    return 'document';
  }

  if (ext === 'pdf') {
    return 'pdf';
  }

  return undefined;
};

export const getFileTypeName = (type: string): string => {
  if (type.startsWith('image/')) return 'Image';
  if (type.startsWith('video/')) return 'Video';
  if (type.startsWith('audio/')) return 'Audio';
  if (type.startsWith('text/')) return 'Text';
  if (type === 'application/pdf') return 'PDF Document';
  return type || 'Unknown type';
};

export const isImageFile = (file: File): boolean => {
  return file.type.startsWith('image/');
};
